// load all certificates that are linked to this order
// then show minimal info - basically need to know what stage they are in

import { statusColours } from "lib/constants";
import { findOneInArray, formatTimestampNicelyDateTime } from "lib/useful";
import useLoad from "lib/useLoad";

function SearchResultShopifyWithShopifyLoaded({ q, r, researches, setAndDo }) {
  const { data: researchData } = useLoad("researchData", {
    _certId: { $in: researches.map((r) => r._id) },
  });

  if (researchData === undefined)
    return (
      <div className="text-2xl text-slate-700 h-48 grid place-content-center">
        Loading research data&hellip;
      </div>
    );

  const stages = [
    "new",
    "typing",
    "typochecking",
    "techchecking",
    "fulfilling",
    "complete",
    "oldCert",
  ];

  return (
    <>
      {researches.map((i, iIndex) => {
        const rd = findOneInArray(researchData, "_certId", i._id, null);

        switch (i.lineItemName) {
          case "Heritage Certificate":
          case "Premier Heritage Certificate":
          case "Heritage Certificate Re-issue":
          case "Premier Heritage Certificate Re-issue":
          case "Digital Heritage Certificate":
          case "Digital Premier Heritage Certificate":
          case "Digital Heritage Certificate Add-on":
          case "Digital Premier Heritage Certificate Add-on":
            return (
              <div key={iIndex} className={`mb-2 p-2 text-xl border`}>
                {i.certNumber ? (
                  <span>
                    <a
                      className="cursor-pointer text-slate-800 hover:underline font-bold"
                      //onClick={() => setAndDo(i.certNumber)}
                      href={`/search1?q=${btoa(i.certNumber)}#${btoa(i.certNumber)}`}
                    >
                      {i.certNumber}
                    </a>
                    : {i.lineItemName} -{" "}
                    <span className={statusColours[i.status]}>{i.status}</span>
                  </span>
                ) : (
                  <span>
                    {i.lineItemName} -{" "}
                    <span className={statusColours[i.status]}>{i.status}</span>
                  </span>
                )}
                {i.status === "suspended" ? (
                  <div className="m-2 border text-lg bg-red-100 p-2">
                    <p>Suspended by {rd?.suspendedBy}</p>
                    <p>Reason: {rd?.suspendedReason}</p>
                    <p>
                      at {formatTimestampNicelyDateTime(rd.suspendedTimestamp)}
                    </p>
                  </div>
                ) : (
                  <div className="m-2 text-sm w-full">
                    <ul className="steps steps-vertical lg:steps-horizontal">
                      {stages.map((s, si) => (
                        <li
                          key={s}
                          className={`p-2 step ${
                            stages.findIndex((st) => st === i.status) >= si
                              ? "step-primary"
                              : ""
                          }`}
                        >
                          {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          default:
            return (
              <div
                key={iIndex}
                className="mb-2 p-2 text-xl border text-black/75"
              >
                {i.lineItemName}
              </div>
            );
        }
      })}
      <a
        href={`https://certificates-3.myshopify.com/admin/orders/${r.result.id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline text-slate-900"
      >
        Shopify Order Id: {r.result.id} (click to view on Shopify)
      </a>
    </>
  );
}

export default function SearchResultShopify({ q, r, setAndDo }) {
  const { data: researches } = useLoad("certificateResearch", {
    shopifyOrdersId: r.result._id,
  });

  if (researches === undefined)
    return (
      <div className="text-2xl text-slate-700 h-48 grid place-content-center">
        Loading Shop order details&hellip;
      </div>
    );

  return (
    <SearchResultShopifyWithShopifyLoaded
      q={q}
      r={r}
      researches={researches}
      setAndDo={setAndDo}
    />
  );
}
